import { Navigate } from "react-router-dom";
import { PAGE_TITLES } from "@miplatform/constants";
import { CreateNewOrder } from "../../views/Orders/CreateNewOrder/CreateNewOrder";
import { Orders } from "../../views/Orders/Orders";

export const schedulingRoutes = [
  {
    path: "/scheduling/orders",
    name: "Orders",
    exact: true,
    element: <Navigate to="all" replace />,
  },
  {
    path: "/scheduling/orders/create",
    name: "Create New Order",
    element: <CreateNewOrder />,
    handle: { title: PAGE_TITLES.NEW_ORDER },
  },
  {
    path: "/scheduling/orders/:tab",
    name: "Orders",
    element: <Orders />,
    handle: { title: PAGE_TITLES.ORDERS },
  },
];
